<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="padding-top: 250px; text-align: center;">"When to the sessions of sweet silent thought,</p>
<p style="text-align: center;">I summon up remembrance of things past,</p>
<p style="text-align: center;">I sigh the lack of many a thing I sought,</p>
<p style="text-align: center;">And with old woes now wail</p>
<p style="text-align: center;">My dear time’s waste."</p>
<br/>
<p style="text-align: right;">– William Shakespeare</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?7a0374fc